
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

export default class WebSocketClient {

    constructor(URL = null) {
        this.subscriptions = {};
        this.queue = {};
        this.connected = false;
        this.client = null;
        this.URL = URL;
    }

    connect(url) {
        const URL = typeof url != "undefined" && url ? url : this.URL;
        if (!this.isConnected() && URL) {
            let sockJS = new SockJS(URL);
            this.client = Stomp.over(sockJS);
            const that = this;
            this.client.connect({}, () => { that.onConnected() }, () => { that.onError() });
        }
    }
    isConnected() {
        return this.connected;
    }

    onConnected() {
        this.connected = true;
        // console.log("is connected");
        this.subscribeFromQueue();


        // stompClient.subscribe(
        // "/user/" + 51 + "/notifications",
        // onMessageReceived
        // );
    };

    onError() {
        console.log("error");
    }


    subscribe(subscriberId, endpoint, onMessageReceived, renew = false) {
        const key = subscriberId + "#" + endpoint;
        if (!renew && typeof this.subscriptions[key] != "undefined") {
            return;
        }
        if (typeof this.queue[key] == "undefined") {
            this.queue[key] = { endpoint, onMessageReceived };
        }
        this.subscribeFromQueue();
    }
    unsubscribe(key) {
        try {
            this.subscriptions[key].unsubscribe();
        } catch(error) {

        }
    }
    /**
     * 
     * 
     */
    subscribeFromQueue() {
        if (this.isConnected()) {
            const queue = { ...this.queue };
            for (const [key, item] of Object.entries(queue)) {
                this.unsubscribe(key);
                this.subscriptions[key] = this.client.subscribe(item.endpoint, item.onMessageReceived);
                delete this.queue[key];
            }
        }
    }
}
